import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { FormattedMessage, FormattedRelativeTime } from 'react-intl-next';
import { WithCustomIntlProvider } from '@atlassian/mpt-utils';
import { fetchLanguageFile } from '../../utils/i18n';
import { messages } from './messages';
var SECOND = 1;
var MINUTE = 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var WEEK = DAY * 7;
var MONTH = WEEK * 4.345;
var YEAR = MONTH * 12;
var units = [['year', YEAR], ['month', MONTH], ['week', WEEK], ['day', DAY], ['hour', HOUR], ['minute', MINUTE], ['second', SECOND]];
var getRelativeTimeProps = function getRelativeTimeProps(timeDifferenceInSeconds) {
  var relevantUnit = units.find(function (unit) {
    return timeDifferenceInSeconds >= unit[1];
  }) || units[0];
  var props = {
    value: -Math.floor(timeDifferenceInSeconds / relevantUnit[1]),
    unit: relevantUnit[0]
  };

  // Only create the update interval if time difference in seconds, minutes or hours
  // FormattedRelativeTime no longer supports higher than 'hour' for interval update
  // read "Limitation" on https://formatjs.io/docs/react-intl/components/#formattedrelativetime
  if (['second', 'minute', 'hour'].includes(relevantUnit[0])) {
    return _objectSpread(_objectSpread({}, props), {}, {
      updateIntervalInSeconds: 60
    });
  }
  return props;
};
var TimeAgo = function TimeAgo(_ref) {
  var date = _ref.date;
  var differenceInSeconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
  var isLessThanOneMinuteAgo = differenceInSeconds < 60;
  var _useState = useState(isLessThanOneMinuteAgo),
    _useState2 = _slicedToArray(_useState, 2),
    showJustNow = _useState2[0],
    setShowJustNow = _useState2[1];
  useEffect(function () {
    var timeout;
    if (isLessThanOneMinuteAgo) {
      setShowJustNow(true);
      // gonna refresh only once after difference time has passed
      var refreshTime = (60 - differenceInSeconds) * 1000;
      timeout = setTimeout(function () {
        setShowJustNow(false);
      }, refreshTime);
    }
    return function () {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [differenceInSeconds, isLessThanOneMinuteAgo]);
  if (showJustNow) {
    return /*#__PURE__*/React.createElement(FormattedMessage, messages.justNow);
  }
  return /*#__PURE__*/React.createElement(FormattedRelativeTime, _extends({
    numeric: "always"
  }, getRelativeTimeProps(differenceInSeconds)));
};
export default WithCustomIntlProvider(TimeAgo, fetchLanguageFile);